@if (screenSize() === "desktop" || screenSize() === "tablet") {
  <nav class="nav-bar">
    <button routerLink="" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      Home
    </button>
    <button routerLink="entities" routerLinkActive="active">
      Manage Entities
    </button>
    <button routerLink="facilities" routerLinkActive="active">
      Manage Facilities
    </button>
    <button routerLink="users" routerLinkActive="active">
      Manage Users
    </button>
    <button [matMenuTriggerFor]="audit">
      Audit Logs
      <mat-icon aria-hidden="false" aria-label="Audit logs menu" fontIcon="arrow_drop_down"/>
    </button>
    <button routerLink="submissions" routerLinkActive="active">
      Submissions
    </button>
  </nav>
} @else {
  <nav class="nav-mobile-left">
    <button mat-icon-button [matMenuTriggerFor]="mobileNavMenu">
      <mat-icon aria-hidden="false" aria-label="Menu" fontIcon="view_headline"></mat-icon>
    </button>
  </nav>

  <mat-menu #mobileNavMenu>
    <div class="nav-login-info-container">
      <div class="nav-login-info">
        <p>Welcome, {{ authService.name() }}</p>
      </div>
    </div>

    <button mat-menu-item routerLink="">
      Home
    </button>
    <button mat-menu-item routerLink="/entities">
      Manage Entities
    </button>
    <button mat-menu-item routerLink="/facilities">
      Manage Facilities
    </button>
    <button mat-menu-item routerLink="/users">
      Manage Users
    </button>
    <button mat-menu-item [matMenuTriggerFor]="audit">
      Audit Logs
    </button>
    <button mat-menu-item routerLink="/submissions" routerLinkActive="active">
      Submissions
    </button>
    <button mat-menu-item (click)="authService.logout()">
      Logout
    </button>
  </mat-menu>
}

<mat-menu #audit>
  <button mat-menu-item routerLink="auditlogs/external">
    External User Events
  </button>
  <button mat-menu-item routerLink="auditlogs/internal">
    Internal User Events
  </button>
</mat-menu>
